import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Error } from 'src/app/models/error.model';
import {
  GraphService,
  TeamsStatus,
} from 'src/app/services/graph/graph.service';
import { lastValueFrom, Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { UserInfo } from 'src/app/models/user-info.model';
import { TeamsListFields } from 'src/app/models/teams-list-fields.model';
import { AddUserDialogComponent } from '../../exchange/adduser-dialog/adduser-dialog.component';
import { ToolBoxService } from 'src/app/services/toolbox/toolbox.service';
import { entAnimations } from 'src/app/animations';
import { TranslateModule } from '@ngx-translate/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MaterialModule } from 'src/app/material/material.module';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { GECorrespondingTable } from 'src/app/models/ge-corresponding-table.model';

@Component({
  selector: 'app-teams-add-dialog',
  standalone: true,
  imports: [TranslateModule, MatStepperModule, MaterialModule],
  templateUrl: './teams-add-dialog.component.html',
  styleUrls: ['./teams-add-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
})
export class TeamsAddDialogComponent implements OnInit {
  @Input() isClassTeams: boolean;

  errorCreateTeams: Error = { error: { message: '', code: '' } };
  isErrorCreateTeams = false;
  isTeamsCreated = false;
  isBusyCreateTeams = false;
  selectedEtablissement: string;
  currentGECorrespondingTable: GECorrespondingTable;

  error: Error = { error: { message: '', code: '' } };

  nameValidator = "^[a-zA-Z0-9][a-zA-Z0-9 '_-]{1,48}[a-zA-Z0-9]$";

  addTeamsForm: FormGroup;

  users_owner: UserInfo[] = [];

  isAddPrincipalOwnerDisabled = false;

  currentGE = '';
  currentSchoolYear = '';
  nextSchoolYear = '';

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  private subscription: Subscription = new Subscription();

  constructor(
    public matDialogRef: MatDialogRef<TeamsAddDialogComponent>,
    private _formBuilder: FormBuilder,
    private _graphService: GraphService,
    private _localStorageService: LocalStorageService,
    private _matDialog: MatDialog,
    private _toolBoxService: ToolBoxService,
    private _settingsService: SettingsService,
    private _toolboxService: ToolBoxService
  ) {}

  async ngOnInit(): Promise<void> {
    const geSubscription = this._settingsService.currentGE$.subscribe(ge => {
      this.selectedEtablissement = ge;
    });
    this.subscription.add(geSubscription);

    this.selectedEtablissement = await this._toolboxService.getUserEtablissement();


    this.addTeamsForm = this._formBuilder.group({
      teamsName: [
        '',
        [Validators.required, Validators.pattern(this.nameValidator)],
      ],
      teamsType: [this.isClassTeams ? 'EDU_Class' : '', Validators.required],
      teamsDescription: [''],
      teamsLifespan: [
        !this.isClassTeams ? 'Equipe permanente' : '',
        Validators.required,
      ],
    });
    this.currentGE = this._localStorageService.getItem<string>('userDefaultGE');
    this.currentSchoolYear = this._toolBoxService.getCurrentSchoolYear();
    this.nextSchoolYear = this._toolBoxService.getNextSchoolYear();
    this.currentGECorrespondingTable = {
      title: this.currentGE,
    };
    this.getGECorespondingTable();
  }

  async getGECorespondingTable(): Promise<void> {
    try {
      await lastValueFrom(
        this._graphService.selectGeInCorrespondingTable(
          this.currentGECorrespondingTable
        )
      ).then(ge => {
        this.currentGECorrespondingTable = ge;
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else {
          if (error.error) {
            customError = error.error;
          }
        }
      }

      if (customError.error === undefined) {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      }
    }
  }

  canShowNextYear(): boolean {
    return this._toolBoxService.canShowNextYear();
  }

  removeUsersOwner(user: UserInfo): void {
    const index = this.users_owner.indexOf(user);
    if (index >= 0) {
      this.users_owner.splice(index, 1);
    }
  }

  step1Validation(): boolean {
    return (
      this.addTeamsForm.get('teamsName').valid &&
      this.addTeamsForm.get('teamsType').valid
    );
  }

  addUsersOwner(): void {
    const dialogRef = this._matDialog.open(AddUserDialogComponent, {
      data: {
        _users: [...this.users_owner.map(user => user.officialemail)],
        singleUser: false,
      },
      panelClass: 'add-user-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((selectedusers: UserInfo[]) => {
      for (const user of selectedusers) {
        const temp = new UserInfo();
        temp.officialemail = user.officialemail;
        this.users_owner.push(temp);
      }
    });
  }

   createDisplayName() {
    let name = this.addTeamsForm.get('teamsName').value;
    if (name !== '') {
      if(!this.isClassTeams){
        name = this.currentGECorrespondingTable.service + " - Team"+name;
      }else{
        name = this.currentGECorrespondingTable.service + " - " + name;
      }
      
    }

    return name;
  }

  createMailAddress() {
    let name = this.addTeamsForm.get('teamsName').value;
    if (name !== '') {
      name = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      name = name.replace(/[^a-zA-Z0-9._-]/g, '');
      if(!this.isClassTeams){
        name = this.currentGECorrespondingTable.service.replace(' ', '-') + '_Team_' + name
      }else{
        if(this._toolBoxService.getCurrentLanguage().includes('fr')){
          name = 'c_' + name;
        }else{
          name = 'k_' + name;
        }
        name += "_"+ this._toolBoxService.formatYear(this.selectedLifespan) + "_" + this.currentGECorrespondingTable.service.replace(' ', '-');
      }
    }

    return name
  }

  private fetchTeamsformData(): TeamsListFields {
    const nomUserOwners = [];
    for (const user of this.users_owner) {
      nomUserOwners.push(user.officialemail);
    }
    return {
      type: 'Teams',
      rqEtat: TeamsStatus.CREATE,
      cogeTxt: this.firstCharToUpper(this.selectedEtablissement),
      rqdaEdited: new Date(),
      rqdaCreated: new Date(),
      coName: this.addTeamsForm.get('teamsName').value as string,
      title: this.createDisplayName() + (this.isClassTeams ? " - "+ this._toolBoxService.formatYear(this.selectedLifespan) : ''),
      coDisplayName: (this.isClassTeams ? this._toolBoxService.formatYear(this.selectedLifespan) + " - " : '')+ this.createDisplayName(),
      rqugEmailAddresses: this.createMailAddress()+'@myeduvs.onmicrosoft.com',
      ...(this.isClassTeams && {
        coSchoolYear: this._toolBoxService.formatYear(this.selectedLifespan),
      }),
      rqteTemplate: this.selectedType,
      rqugLanguage: this._toolBoxService.getCurrentLanguage(),
      rqugOwners: this.users_owner.map(user => user.officialemail).join(';'),
    };
  }

  async createTeams(): Promise<void> {
    this.errorCreateTeams = { error: { message: '', code: '' } };
    this.isErrorCreateTeams = false;
    this.isTeamsCreated = false;
    this.isBusyCreateTeams = true;

    try {
      const newTeams = this.fetchTeamsformData();
      const type = this.isClassTeams ? 'Teams-class' : 'Teams';
      await lastValueFrom(this._graphService.addTeams(newTeams, type)).then(
        () => {
          this.isTeamsCreated = true;
          this.isBusyCreateTeams = false;
        }
      );
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else {
          if (error.error) {
            customError = error.error;
          }
        }
      }

      if (customError.error === undefined) {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      }

      this.isErrorCreateTeams = true;
      this.errorCreateTeams = customError;
      this.isTeamsCreated = false;
      this.isBusyCreateTeams = false;
    }
  }

  private firstCharToUpper(input: string | boolean): string {
    return String(input).charAt(0).toUpperCase() + String(input).slice(1);
  }

  get selectedType(): string {
    return this.addTeamsForm.get('teamsType').value as string;
  }

  get selectedLifespan(): string {
    return this.addTeamsForm.get('teamsLifespan').value ? this.addTeamsForm.get('teamsLifespan').value : this._toolBoxService.getCurrentSchoolYear() as string;
  }
}
